






































































import { Component, Vue, Prop } from "vue-property-decorator";
import ApolloClient, { serverBase } from "@/apollo";
import gql from "graphql-tag";
import IActor from "@/types/actor";
import { contextModule } from "@/store/context";
import { copy } from "@/util/object";
import { ensureDarkColor } from "@/util/color";

@Component
export default class ActorCard extends Vue {
  @Prop(Object) value!: IActor;
  @Prop({ default: true }) showLabels!: boolean;

  get fillThumbnail() {
    return contextModule.fillActorCards;
  }

  get cardColor() {
    if (this.value.thumbnail && this.value.thumbnail.color)
      return ensureDarkColor(this.value.thumbnail.color);
    return null;
  }

  get aspectRatio() {
    return contextModule.actorAspectRatio;
  }

  rate($event) {
    const rating = $event;

    ApolloClient.mutate({
      mutation: gql`
        mutation($ids: [String!]!, $opts: ActorUpdateOpts!) {
          updateActors(ids: $ids, opts: $opts) {
            rating
          }
        }
      `,
      variables: {
        ids: [this.value._id],
        opts: {
          rating,
        },
      },
    }).then((res) => {
      const actor = copy(this.value);
      actor.rating = res.data.updateActors[0].rating;
      this.$emit("input", actor);
    });
  }

  favorite() {
    ApolloClient.mutate({
      mutation: gql`
        mutation($ids: [String!]!, $opts: ActorUpdateOpts!) {
          updateActors(ids: $ids, opts: $opts) {
            favorite
          }
        }
      `,
      variables: {
        ids: [this.value._id],
        opts: {
          favorite: !this.value.favorite,
        },
      },
    }).then((res) => {
      const actor = copy(this.value);
      actor.favorite = res.data.updateActors[0].favorite;
      this.$emit("input", actor);
    });
  }

  bookmark() {
    ApolloClient.mutate({
      mutation: gql`
        mutation($ids: [String!]!, $opts: ActorUpdateOpts!) {
          updateActors(ids: $ids, opts: $opts) {
            bookmark
          }
        }
      `,
      variables: {
        ids: [this.value._id],
        opts: {
          bookmark: this.value.bookmark ? null : Date.now(),
        },
      },
    }).then((res) => {
      const actor = copy(this.value);
      actor.bookmark = res.data.updateActors[0].bookmark;
      this.$emit("input", actor);
    });
  }

  get thumbnail() {
    if (this.value.thumbnail)
      return `${serverBase}/media/image/${this.value.thumbnail._id}?password=${localStorage.getItem(
        "password"
      )}`;
    return `${serverBase}/broken`;
  }

  get altThumbnail() {
    if (this.value.altThumbnail)
      return `${serverBase}/media/image/${
        this.value.altThumbnail._id
      }?password=${localStorage.getItem("password")}`;
    return null;
  }
}
